import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'poItems'
})
export class PoItemsPipe implements PipeTransform {

  transform(value: any): any {
    return value.filter(inv => {
      return !inv.parent;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/pipes/po-items-pipe.ts